import { render, staticRenderFns } from "./DescargaDB.vue?vue&type=template&id=13ab8ef9&scoped=true"
import script from "./DescargaDB.vue?vue&type=script&lang=js"
export * from "./DescargaDB.vue?vue&type=script&lang=js"
import style0 from "./DescargaDB.vue?vue&type=style&index=0&id=13ab8ef9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ab8ef9",
  null
  
)

export default component.exports